import { Routes } from '@angular/router';

// Views.
import { QSignerComponent } from '@views/qSigner/qSigner.component';
import { QSignerHomeComponent } from '@views/qSignerHome/qSignerhome.component';
import { QWebPrinterComponent } from '@views/qWebPrinter/qWebPrinter.component';

export const ROUTES: Routes = [
  {
    path: 'qsigner',
    component: QSignerComponent,
  },
  {
    path: 'qwebprinter',
    component: QWebPrinterComponent,
  },
  {
    path: 'qsignerhome',
    component: QSignerHomeComponent,
  },
  { path: '**', redirectTo: 'home' },
];
